import React from "react";
import PageShell from "../common/page_shell";
import AiTools from "../inner/ai/ai_tools";
import data from "../data/biodata.json";

const AiPage = () => {
  return (
    <PageShell>
      <AiTools list={data?.details?.ai_tools || []} />
    </PageShell>
  );
};

export default AiPage;
